import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userDataState } from '../State';
import { UserData } from '../types/UserData';
import posthog from 'posthog-js'

export function DocumentHead(props: { title: string; projectNumber: string; subPageTitle: string;}) {
  const userData = useRecoilValue<UserData>(userDataState);
  const location = useLocation();
  useEffect(() => {
    if (userData.d || userData.emp || userData.g || userData.l || userData.re || userData.sp) {
      posthog.capture('ApexPageview', {
        page_title: props.title,
        project_number: props.projectNumber,
        subpage_title: props.subPageTitle
      });
      return () => {
        console.log(`[DocumentHead] Unmounting ${props.title}|${location.pathname}|document.title:${document.title}`);
      };
    }
  }, [location.pathname]);
  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name="description" content={`${props.title} component`} />
    </Helmet>
  );
}
